import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridRow, GridColumn } from "arv-reactcomponents";
import { Anchor, Analytics } from "arv-extends";
import { FOOTER } from "npmlinks-constants";

const { TITLE, URL, CTA } = FOOTER.STORE_LOCATOR;

@inject("CommonStore")
@observer
class StoreLocatorLink extends Component {
  render() {
    const { className } = this.props;
    const { isDesktop } = this.props.CommonStore;

    return (
      <GridColumn className={className}>
        <GridRow className="wc-footermainbar-storelocatorcontainer">
          <GridColumn>
            <h3 className="wc-footermainbar-storelocatorheading">{TITLE}</h3>
          </GridColumn>
          <GridColumn>
            <Anchor.component
              to={URL}
              href={URL}
              onClick={() =>
                Analytics.GTM.pushEvent(
                  Analytics.EventFactory.GTMEvent.CONTACTUS_CLICK
                )
              }
              className="wc-footermainbar-storelocatoractions"
              target={isDesktop ? "_blank" : "_self"}
            >
              <i className="icomoon-phone wc-footermainbar-storelocatoricon" />
              {CTA}
            </Anchor.component>
          </GridColumn>
        </GridRow>
      </GridColumn>
    );
  }
}

StoreLocatorLink.propTypes = {
  className: PropTypes.string.isRequired
};

export default StoreLocatorLink;